<script setup lang="ts">
import type { BreadcrumbItem } from "@nuxt/ui";

defineProps<{ items: BreadcrumbItem[] }>();

const { t } = useI18n();
const expanded = ref(false);
</script>

<template>
  <div class="flex flex-col gap-2">
    <UBreadcrumb
      :items="items"
      separator-icon="icon:arrowRight"
      :aria-label="t('ui.breadcrumb.label')"
      :class="{ 'max-sm:hidden': !expanded }"
      :ui="{ list: 'flex-wrap' }"
    />
    <UButton
      v-if="!expanded"
      variant="link"
      size="sm"
      class="sm:hidden underline-offset-[.18em]"
      :aria-expanded="expanded"
      @click="() => { expanded = !expanded }"
    >
      {{ !expanded ? t("ui.breadcrumb.show") : t("ui.breadcrumb.hide") }}
    </UButton>
  </div>
</template>
